module.exports = __webpack_public_path__ + "img/platform-activities-3-days-in-row.cbbb05b2.png";